import { Tab } from "@headlessui/react";
import Divider from "../Divider";
//@ts-ignore
import { tw } from "@careinfo/tailwind";
import { classNames } from "../../utils/classNames";
type Props = {
  tabTitle: any;
  tabPanels: any;
};

const TabPanel = (props: Props) => {
  const { tabTitle, tabPanels } = props;

  return (
    <div
      className={tw`flex flex-col h-full rounded-md bg-white mt-4 mb-4 outline-none`}
    >
      <Tab.Group as="div" className={tw`flex flex-col flex-1 min-h-0`}>
        <Tab.List className={tw`flex`}>
          {tabTitle?.map((elem: any) => {
            return (
              <Tab
                key={elem}
                className={({ selected }) =>
                  classNames(
                    tw`text-md capitalize p-2 px-2 first:rounded-tl-md outline-none focus:outline-none`,
                    selected
                      ? tw`bg-gray-50 shadow border-b border-0 border-primary`
                      : tw`hover:bg-gray-200 text-gray-600 hover:text-gray-700 bg-gray-200`
                  )
                }
              >
                {elem}
              </Tab>
            );
          })}
        </Tab.List>

        <Divider />

        <Tab.Panels className={tw`flex-1 overflow-auto`}>
          {tabPanels?.map((elem: any, index: number) => {
            return (
              <Tab.Panel className={tw`p-2 h-full`} key={index}>
                {elem}
              </Tab.Panel>
            );
          })}
        </Tab.Panels>
      </Tab.Group>
    </div>
  );
};

export default TabPanel;
